export default __webpack_public_path__ + "static/media/‌Josh ‌Goldberg.e0b6c219.png";